
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33930',
  depVersions: {
  "documents-public-ui": "static-1.33930",
  "client-types": "static-1.444",
  "documents-lib": "static-1.33935",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1910",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.99",
  "hs-promise-utils": "static-1.5376",
  "hs-test-utils": "static-1.7789",
  "hub-http": "static-1.5966",
  "hubspot-dlb": "static-2.1796",
  "HubStyleTokens": "static-2.11207",
  "I18n": "static-7.1564",
  "jasmine-immutable": "static-1.2802",
  "jasmine-runner": "static-1.6256",
  "lodash": "static-1.3",
  "quartz": "static-1.6704",
  "react": "static-7.177",
  "react-dlb": "static-1.71",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16427",
  "reporting-data": "static-1.66451",
  "reporting-testing-lib": "static-1.8384",
  "reporting-visualizations": "static-1.58527",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4550",
  "webpack-env": "static-1.54",
  "atom": "static-1.4854",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2268",
  "classnames": "static-2.10",
  "cssUtils": "static-1.726",
  "customer-data-filters-ui": "static-1.38851",
  "customer-data-objects": "static-1.7430",
  "customer-data-property-utils": "static-1.7857",
  "data-fetching-client": "static-1.9463",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4313",
  "flux-actions": "static-1.306",
  "FormsCommonComponents": "static-1.85257",
  "FormUrlGenerator": "static-2.4514",
  "foundations-components": "static-1.7492",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3917",
  "HubStyle": "static-2.11515",
  "icons": "static-2.620",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6946",
  "metrics-js": "static-1.9391",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3643",
  "property-translator": "static-1.5197",
  "quartz-config": "static-1.482",
  "quartz-core": "static-1.5923",
  "quick-fetch": "static-1.3719",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5158",
  "react-virtualized": "static-2.94",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7945",
  "reference-resolvers-lite": "static-1.7875",
  "report-customization-components": "static-1.12460",
  "reporting-enablement": "static-1.22020",
  "reporting-reports": "static-1.66129",
  "reporting-snowflake": "static-1.55069",
  "reporting-ui-components": "static-2.63722",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4416",
  "sales-content-partitioning": "static-1.8719",
  "SalesContentIndexUI": "static-3.8876",
  "sanitize": "static-1.4259",
  "sanitize-text": "static-1.7923",
  "self-service-api": "static-1.10020",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1538",
  "signup-constants": "static-1.18351",
  "signup-ui-lego-core": "static-1.20361",
  "signup-ui-url-generator": "static-2.7852",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.483",
  "superstore": "static-1.4555",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10778",
  "ui-addon-i18n": "static-1.10919",
  "ui-addon-react-router-dom": "static-1.9332",
  "ui-addon-upgrades": "static-9.17627",
  "ui-asset-management-lib": "static-1.10686",
  "ui-images": "static-2.1087",
  "UIComponents": "static-3.8154",
  "usage-tracker": "static-1.7116",
  "usage-tracker-container": "static-1.7106",
  "usage-tracker-core": "static-1.6966",
  "usage-tracker-public": "static-1.6927",
  "viral-links-lib": "static-1.6817",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3211",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2981",
  "quartz-webpack": "static-1.2928",
  "ai-components-ui-library": "static-1.8305",
  "amplitude-session-replay-browser": "static-1.55",
  "foundations-assets": "static-1.4619",
  "foundations-theming": "static-1.4194",
  "quartz-auth": "static-1.379",
  "usage-tracker-session-replay": "static-1.4802",
  "foundations-theming-base": "static-1.3179",
  "HeadJS": "static-2.706",
  "framer-motion": "static-1.67",
  "hs-test-utils-bend-plugin": "static-1.2900",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4112",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7708",
  "graphql": "static-1.77",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3402",
  "persist-promise": "static-1.3490",
  "reporting-client-types": "static-1.2385",
  "foundations-components-legacy": "static-1.517",
  "hs-story-utils": "static-1.9213",
  "react-flip-move": "static-1.65",
  "hub-http-shared-msw-handlers": "static-1.9440",
  "hubspotter-http": "static-1.4462",
  "sassPrefix": "static-1.151",
  "conversations-skeleton-state": "static-1.7032",
  "crm-message-bus": "static-1.42312",
  "customer-data-filters-ui-msw-helpers": "static-1.21285",
  "customer-data-objects-ui-components": "static-1.12789",
  "customer-data-reference-ui-components": "static-1.12926",
  "customer-data-ui-utilities": "static-1.9609",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6559",
  "framework-data-schema-resolvers": "static-1.6654",
  "inbound-db-properties-service-client": "static-1.3660",
  "multi-account-reference-resolvers": "static-1.755",
  "onboarding-tours": "static-1.16232",
  "reporting-datasets-permissions-lib": "static-1.12991",
  "ui-addon-teams": "static-1.21218",
  "apollo-stack-hubspot": "static-3.81",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67576",
  "customer-data-properties": "static-1.50756",
  "forms-ai-lib": "static-1.3987",
  "forms-utils-lib": "static-1.12138",
  "foundations-components-test-utils": "static-1.4975",
  "react-dnd-compat": "static-1.4406",
  "react-tinymce": "static-1.54575",
  "tinymce-config": "static-2.53701",
  "ui-gdpr-components": "static-1.10131",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3761",
  "floating-ui": "static-1.51",
  "react-aria": "static-1.61",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1145",
  "ui-fonts": "static-1.469",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.789",
  "mobile-manifest-mixins": "static-1.479",
  "module-federation": "static-1.18",
  "quartz-head": "static-1.369",
  "quartz-i18n": "static-1.379",
  "quartz-routing": "static-1.134",
  "quartz-test": "static-1.379",
  "batch-promise": "static-1.1333",
  "external-options-client-types": "static-1.3969",
  "react-colorpicker": "static-2.9995",
  "copilot-toolkit": "static-1.10482",
  "data-quality-ui-library": "static-1.12282",
  "html-to-image": "static-1.49",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40616",
  "reporting-insights-lib": "static-1.1117",
  "reporting-plugins": "static-1.9960",
  "ui-addon-draggable-compat": "static-2.4037",
  "ui-addon-opt": "static-4.8169",
  "ui-shepherd-react": "static-3.9929",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24686",
  "hubspot-apollo-client": "static-1.4664",
  "sales-templates-service-types-lib": "static-1.3979",
  "ui-business-units-lib": "static-1.8810",
  "merchandise-lib": "static-1.258",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5460",
  "salesImages": "static-1.520",
  "ts-schema": "static-1.3888",
  "timezone-utils": "static-2.5029",
  "bender-build-tools": "static-1.2926",
  "chatspot-core": "static-1.20243",
  "chirp-fetch": "static-1.1667",
  "bend-plugin-foundations-theming": "static-1.2677",
  "stylex": "static-1.27",
  "hubspotter-http-shared-msw-handlers": "static-1.9438",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3608",
  "crm-pipelines-api-client-types": "static-1.3949",
  "multi-currency-client-types": "static-1.3502",
  "getting-started-shared-tasks": "static-1.17839",
  "growth-data-modal": "static-1.5134",
  "growth-onboarding-confetti": "static-1.2854",
  "growth-onboarding-next-action-utils": "static-1.1280",
  "navigation-components": "static-1.17219",
  "onboarding-tours-client": "static-1.4446",
  "onboarding-tours-utils": "static-1.298",
  "ui-shepherd-tracker": "static-1.7310",
  "ui-universal-auth": "static-1.8670",
  "user-context": "static-1.4879",
  "cms-field-types": "static-1.4589",
  "content-icons-ui": "static-1.2148",
  "integrations-lib": "static-1.15366",
  "calling-global-api": "static-1.63600",
  "calling-internal-common": "static-1.31074",
  "calling-lifecycle-internal": "static-1.64982",
  "calling-lifecycle-messages": "static-1.57276",
  "commerce-products-lib": "static-1.8816",
  "crm-links": "static-1.6042",
  "file-manager-components": "static-1.22843",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.459",
  "inbounddb-objects-service-types": "static-1.4034",
  "meetings-icalendar-utils-lib": "static-1.417",
  "object-builder-ui-client": "static-1.47916",
  "pipeline-validation-client-types": "static-1.3771",
  "property-value-citations": "static-1.1370",
  "pulse": "static-1.290",
  "smart-property-lib": "static-1.5841",
  "tiered-pricing": "static-1.804",
  "ui-addon-iframeable": "static-1.8826",
  "final-form": "static-1.65",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19443",
  "tinymce-themes": "static-1.55671",
  "data-token-picker": "static-1.16015",
  "hub-http-contrib": "static-1.2829",
  "interframe": "static-3.4575",
  "tinymce-data": "static-1.39786",
  "tinymce-plugins": "static-1.56815",
  "ui-addon-sales-email": "static-1.4997",
  "magpie-lib": "static-1.5378",
  "magpie-types": "static-1.4838",
  "simple-logging-lib": "static-1.2834",
  "content-assistance-lib": "static-1.7425",
  "dashboard-lib": "static-1.80564",
  "ExportDialog": "static-6.10170",
  "hubspot-prosemirror": "static-1.17565",
  "hubspot-prosemirror-plugins": "static-1.17557",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8476",
  "campaign-roi-lib": "static-1.8225",
  "feedback-loader": "static-1.28823",
  "onboarding-scopes": "static-1.6247",
  "apollo-link-hub-http": "static-2.4432",
  "hubspot-apollo-cache": "static-1.123",
  "growth-monetization-service-types": "static-1.4301",
  "nav-client-types": "static-1.2140",
  "purchase-motions-api": "static-1.5463",
  "trials-service-types": "static-1.3702",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.509",
  "unified-auth-core-lib": "static-1.465",
  "getting-started-shared-tasks-store": "static-1.16957",
  "integrations-error-boundary-lib": "static-1.12781",
  "integrations-tracking-lib": "static-1.5369",
  "native-integrations-shared-strings": "static-1.7572",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10157",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31080",
  "shared-worker-versioning": "static-1.10821",
  "calling-usage-tracker": "static-1.6323",
  "voice-sms-access-library": "static-1.201",
  "customer-data-tracking": "static-1.6665",
  "products-iframe-lib": "static-1.7270",
  "products-ui-components-shared-msw-handlers": "static-1.9822",
  "location-customization-utils-lib": "static-1.8514",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3938",
  "video-components-external": "static-1.10514",
  "video-data-lib": "static-1.34172",
  "directed-graph": "static-1.721",
  "event-emitter": "static-1.731",
  "breeze-intelligence-kit": "static-1.5298",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9523",
  "fsm": "static-1.3515",
  "policy-lib": "static-1.6567",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9586",
  "navigation-messaging": "static-1.6546",
  "FileManagerLib": "static-1.38483",
  "NamespacedHubStyle": "static-2.8881",
  "FileManagerCore": "static-1.38342",
  "codemirror": "static-5.90",
  "layout-dnd-components": "static-1.12004",
  "layout-dnd-utils": "static-1.10979",
  "react-codemirror": "static-1.10410",
  "ui-addon-emoji-picker": "static-1.9673",
  "ui-brand-identity-lib": "static-1.13792",
  "ui-addon-video-player": "static-1.8479",
  "ui-coaching-tips": "static-1.27902",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8353",
  "payment-link-components": "static-1.22900",
  "EmailSignatureEditor": "static-1.23873",
  "eligibility-engine-service-types": "static-1.2983",
  "universal-page-editor-lib": "static-1.2782",
  "calling-orchestration-schema": "static-1.34978",
  "sales-views-client-types": "static-1.4076",
  "crm-record-cards-service-types": "static-1.3437",
  "content-media-composition-data-lib": "static-1.11394",
  "content-media-compositions": "static-2.15401",
  "media-bridge-lib": "static-1.18537",
  "trellis-story-utils": "static-1.4307",
  "storybook-react": "static-1.28",
  "audio-components": "static-1.5589",
  "FileManagerImages": "static-1.35994",
  "video-components": "static-1.12517",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4317",
  "video-embed": "static-1.35006",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67651",
  "layout-data-lib": "static-1.9304",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6369",
  "commerce-tours-lib": "static-1.5692",
  "growth-onboarding-reliability": "static-1.4871",
  "sales-checkout-service-client": "static-1.3462",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21281",
  "sales-email-signature-service-client": "static-1.3629",
  "hls.js": "static-1.34",
  "social-insights-client-types": "static-1.21278",
  "outpost": "static-1.3989",
  "advanced-menus-core": "static-1.14788",
  "advanced-menus-lib": "static-1.11767",
  "ui-memberships-settings-lib": "static-1.33385",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14787",
  "simple-menus-lib": "static-1.16304"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33930",
  "client-types": "/client-types/static-1.444",
  "documents-lib": "/documents-lib/static-1.33935",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1910",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.99",
  "hs-promise-utils": "/hs-promise-utils/static-1.5376",
  "hs-test-utils": "/hs-test-utils/static-1.7789",
  "hub-http": "/hub-http/static-1.5966",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "HubStyleTokens": "/HubStyleTokens/static-2.11207",
  "I18n": "/I18n/static-7.1564",
  "jasmine-immutable": "/jasmine-immutable/static-1.2802",
  "jasmine-runner": "/jasmine-runner/static-1.6256",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6704",
  "react": "/react/static-7.177",
  "react-dlb": "/react-dlb/static-1.71",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16427",
  "reporting-data": "/reporting-data/static-1.66451",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8384",
  "reporting-visualizations": "/reporting-visualizations/static-1.58527",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4550",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4854",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2268",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.726",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38851",
  "customer-data-objects": "/customer-data-objects/static-1.7430",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7857",
  "data-fetching-client": "/data-fetching-client/static-1.9463",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4313",
  "flux-actions": "/flux-actions/static-1.306",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85257",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4514",
  "foundations-components": "/foundations-components/static-1.7492",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyle": "/HubStyle/static-2.11515",
  "icons": "/icons/static-2.620",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6946",
  "metrics-js": "/metrics-js/static-1.9391",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3643",
  "property-translator": "/property-translator/static-1.5197",
  "quartz-config": "/quartz-config/static-1.482",
  "quartz-core": "/quartz-core/static-1.5923",
  "quick-fetch": "/quick-fetch/static-1.3719",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5158",
  "react-virtualized": "/react-virtualized/static-2.94",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7945",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7875",
  "report-customization-components": "/report-customization-components/static-1.12460",
  "reporting-enablement": "/reporting-enablement/static-1.22020",
  "reporting-reports": "/reporting-reports/static-1.66129",
  "reporting-snowflake": "/reporting-snowflake/static-1.55069",
  "reporting-ui-components": "/reporting-ui-components/static-2.63722",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4416",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8719",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8876",
  "sanitize": "/sanitize/static-1.4259",
  "sanitize-text": "/sanitize-text/static-1.7923",
  "self-service-api": "/self-service-api/static-1.10020",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1538",
  "signup-constants": "/signup-constants/static-1.18351",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20361",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7852",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "superstore": "/superstore/static-1.4555",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10778",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10919",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9332",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17627",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10686",
  "ui-images": "/ui-images/static-2.1087",
  "UIComponents": "/UIComponents/static-3.8154",
  "usage-tracker": "/usage-tracker/static-1.7116",
  "usage-tracker-container": "/usage-tracker-container/static-1.7106",
  "usage-tracker-core": "/usage-tracker-core/static-1.6966",
  "usage-tracker-public": "/usage-tracker-public/static-1.6927",
  "viral-links-lib": "/viral-links-lib/static-1.6817",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3211",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2981",
  "quartz-webpack": "/quartz-webpack/static-1.2928",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8305",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4619",
  "foundations-theming": "/foundations-theming/static-1.4194",
  "quartz-auth": "/quartz-auth/static-1.379",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4802",
  "foundations-theming-base": "/foundations-theming-base/static-1.3179",
  "HeadJS": "/HeadJS/static-2.706",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2900",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4112",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7708",
  "graphql": "/graphql/static-1.77",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3402",
  "persist-promise": "/persist-promise/static-1.3490",
  "reporting-client-types": "/reporting-client-types/static-1.2385",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.517",
  "hs-story-utils": "/hs-story-utils/static-1.9213",
  "react-flip-move": "/react-flip-move/static-1.65",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9440",
  "hubspotter-http": "/hubspotter-http/static-1.4462",
  "sassPrefix": "/sassPrefix/static-1.151",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7032",
  "crm-message-bus": "/crm-message-bus/static-1.42312",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21285",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12789",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12926",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9609",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6559",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6654",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3660",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.755",
  "onboarding-tours": "/onboarding-tours/static-1.16232",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12991",
  "ui-addon-teams": "/ui-addon-teams/static-1.21218",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67576",
  "customer-data-properties": "/customer-data-properties/static-1.50756",
  "forms-ai-lib": "/forms-ai-lib/static-1.3987",
  "forms-utils-lib": "/forms-utils-lib/static-1.12138",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4975",
  "react-dnd-compat": "/react-dnd-compat/static-1.4406",
  "react-tinymce": "/react-tinymce/static-1.54575",
  "tinymce-config": "/tinymce-config/static-2.53701",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10131",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3761",
  "floating-ui": "/floating-ui/static-1.51",
  "react-aria": "/react-aria/static-1.61",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1145",
  "ui-fonts": "/ui-fonts/static-1.469",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.789",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.479",
  "module-federation": "/module-federation/static-1.18",
  "quartz-head": "/quartz-head/static-1.369",
  "quartz-i18n": "/quartz-i18n/static-1.379",
  "quartz-routing": "/quartz-routing/static-1.134",
  "quartz-test": "/quartz-test/static-1.379",
  "batch-promise": "/batch-promise/static-1.1333",
  "external-options-client-types": "/external-options-client-types/static-1.3969",
  "react-colorpicker": "/react-colorpicker/static-2.9995",
  "copilot-toolkit": "/copilot-toolkit/static-1.10482",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12282",
  "html-to-image": "/html-to-image/static-1.49",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40616",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1117",
  "reporting-plugins": "/reporting-plugins/static-1.9960",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4037",
  "ui-addon-opt": "/ui-addon-opt/static-4.8169",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9929",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24686",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4664",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3979",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8810",
  "merchandise-lib": "/merchandise-lib/static-1.258",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5460",
  "salesImages": "/salesImages/static-1.520",
  "ts-schema": "/ts-schema/static-1.3888",
  "timezone-utils": "/timezone-utils/static-2.5029",
  "bender-build-tools": "/bender-build-tools/static-1.2926",
  "chatspot-core": "/chatspot-core/static-1.20243",
  "chirp-fetch": "/chirp-fetch/static-1.1667",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2677",
  "stylex": "/stylex/static-1.27",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9438",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3608",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3949",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3502",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17839",
  "growth-data-modal": "/growth-data-modal/static-1.5134",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2854",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1280",
  "navigation-components": "/navigation-components/static-1.17219",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4446",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.298",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7310",
  "ui-universal-auth": "/ui-universal-auth/static-1.8670",
  "user-context": "/user-context/static-1.4879",
  "cms-field-types": "/cms-field-types/static-1.4589",
  "content-icons-ui": "/content-icons-ui/static-1.2148",
  "integrations-lib": "/integrations-lib/static-1.15366",
  "calling-global-api": "/calling-global-api/static-1.63600",
  "calling-internal-common": "/calling-internal-common/static-1.31074",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64982",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57276",
  "commerce-products-lib": "/commerce-products-lib/static-1.8816",
  "crm-links": "/crm-links/static-1.6042",
  "file-manager-components": "/file-manager-components/static-1.22843",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.459",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4034",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.417",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47916",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3771",
  "property-value-citations": "/property-value-citations/static-1.1370",
  "pulse": "/pulse/static-1.290",
  "smart-property-lib": "/smart-property-lib/static-1.5841",
  "tiered-pricing": "/tiered-pricing/static-1.804",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8826",
  "final-form": "/final-form/static-1.65",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19443",
  "tinymce-themes": "/tinymce-themes/static-1.55671",
  "data-token-picker": "/data-token-picker/static-1.16015",
  "hub-http-contrib": "/hub-http-contrib/static-1.2829",
  "interframe": "/interframe/static-3.4575",
  "tinymce-data": "/tinymce-data/static-1.39786",
  "tinymce-plugins": "/tinymce-plugins/static-1.56815",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4997",
  "magpie-lib": "/magpie-lib/static-1.5378",
  "magpie-types": "/magpie-types/static-1.4838",
  "simple-logging-lib": "/simple-logging-lib/static-1.2834",
  "content-assistance-lib": "/content-assistance-lib/static-1.7425",
  "dashboard-lib": "/dashboard-lib/static-1.80564",
  "ExportDialog": "/ExportDialog/static-6.10170",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17565",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17557",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8476",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8225",
  "feedback-loader": "/feedback-loader/static-1.28823",
  "onboarding-scopes": "/onboarding-scopes/static-1.6247",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4432",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.123",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4301",
  "nav-client-types": "/nav-client-types/static-1.2140",
  "purchase-motions-api": "/purchase-motions-api/static-1.5463",
  "trials-service-types": "/trials-service-types/static-1.3702",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.509",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.465",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16957",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12781",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5369",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7572",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10157",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31080",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10821",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6323",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.201",
  "customer-data-tracking": "/customer-data-tracking/static-1.6665",
  "products-iframe-lib": "/products-iframe-lib/static-1.7270",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9822",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8514",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3938",
  "video-components-external": "/video-components-external/static-1.10514",
  "video-data-lib": "/video-data-lib/static-1.34172",
  "directed-graph": "/directed-graph/static-1.721",
  "event-emitter": "/event-emitter/static-1.731",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5298",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9523",
  "fsm": "/fsm/static-1.3515",
  "policy-lib": "/policy-lib/static-1.6567",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9586",
  "navigation-messaging": "/navigation-messaging/static-1.6546",
  "FileManagerLib": "/FileManagerLib/static-1.38483",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8881",
  "FileManagerCore": "/FileManagerCore/static-1.38342",
  "codemirror": "/codemirror/static-5.90",
  "layout-dnd-components": "/layout-dnd-components/static-1.12004",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10979",
  "react-codemirror": "/react-codemirror/static-1.10410",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9673",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13792",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8479",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27902",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8353",
  "payment-link-components": "/payment-link-components/static-1.22900",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23873",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2983",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2782",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34978",
  "sales-views-client-types": "/sales-views-client-types/static-1.4076",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3437",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11394",
  "content-media-compositions": "/content-media-compositions/static-2.15401",
  "media-bridge-lib": "/media-bridge-lib/static-1.18537",
  "trellis-story-utils": "/trellis-story-utils/static-1.4307",
  "storybook-react": "/storybook-react/static-1.28",
  "audio-components": "/audio-components/static-1.5589",
  "FileManagerImages": "/FileManagerImages/static-1.35994",
  "video-components": "/video-components/static-1.12517",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4317",
  "video-embed": "/video-embed/static-1.35006",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67651",
  "layout-data-lib": "/layout-data-lib/static-1.9304",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6369",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5692",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4871",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3462",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21281",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3629",
  "hls.js": "/hls.js/static-1.34",
  "social-insights-client-types": "/social-insights-client-types/static-1.21278",
  "outpost": "/outpost/static-1.3989",
  "advanced-menus-core": "/advanced-menus-core/static-1.14788",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11767",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33385",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14787",
  "simple-menus-lib": "/simple-menus-lib/static-1.16304"
}
};
